import script from "./BaseCard.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseCard.vue?vue&type=script&setup=true&lang=js"

import "./BaseCard.vue?vue&type=style&index=0&id=06a6d286&lang=css"
import "./BaseCard.vue?vue&type=style&index=1&id=06a6d286&lang=scss&scoped=true"
script.__scopeId = "data-v-06a6d286"

export default script